// paymentManagment

import { Purchase            ,
         initializedPurchase ,
         EnrichedPurchase    } from '../purchaseManagment/types';

export interface Payment
 {
  id               : number   ,
  amount           : number   ,
  comment          : string   ,
  ipAddress        : string   ,
  creationDate     : Date | null   ,
  paymentReference : string   ,
  transactionId    : string   ,
  meansOfPayment   : string   ,
  status           : string   ,
  isTest           : string   ,
  bankName         : string   ,
  purchase         : Purchase
 }
 
export const initializedPayment = (): Payment => ( 
 {
  id               : 0                     ,   
  amount           : 0                     ,
  comment          : ""                    ,
  ipAddress        : ""                    ,
  creationDate     : null                  ,
  paymentReference : ""                    ,
  transactionId    : ""                    ,
  meansOfPayment   : ""                    ,
  status           : ""                    ,
  isTest           : ""                    ,
  bankName         : ""                    ,
  purchase         : initializedPurchase() , 
});

export interface GetPaymentListParams {
  userEmail?     : string;
  userId?        : number;
  ipAddress?     : string;
  beginningDate? : Date;
  endingDate?    : Date;
}


// Nouvelle interface enrichie pour les paiements
export interface EnrichedPayment extends Payment {
  purchase: EnrichedPurchase;
}

export interface TurnoverAndPaymentCount {
  turnover     : number;
  paymentCount : number;
}
